export interface VoiceRecordingMeta {
  interactionStartedAt: number;
  recordingStartedAt: number;
  recordingEndedAt: number;
  recordingMs: number;
}

export interface BuildVoiceInteractionEventArgs extends VoiceRecordingMeta {
  status: "ok" | "error";
  requestStartedAt: number;
  responseReceivedAt: number;
  responseRenderedAt: number;
  blob: Blob;
  mimeType?: string;
  transcript?: string;
}

export function buildVoiceInteractionEvent(
  args: BuildVoiceInteractionEventArgs,
) {
  const mimeType = args.mimeType || args.blob.type || undefined;
  return {
    event_type: "voice_interaction" as const,
    status: args.status,
    recording_ms: clampMs(args.recordingEndedAt - args.recordingStartedAt),
    request_ms: clampMs(args.responseReceivedAt - args.requestStartedAt),
    end_to_end_ms: clampMs(args.responseRenderedAt - args.interactionStartedAt),
    render_ms: clampMs(args.responseRenderedAt - args.responseReceivedAt),
    mime_type: mimeType,
    byte_count: args.blob.size,
    transcript_chars: args.transcript?.length,
  };
}

function clampMs(value: number): number {
  return Math.max(0, Math.round(value));
}
